import _ from 'underscore';
import tooltipTemplate from './tooltip-template.pug';

export function formatTooltip({
  points,
  i18n,
}) {
  const originalPoints = [];

  _.each(points, (point) => {
    originalPoints.push({ ...point, y: i18n.formatDecimal(point.y) });
  });

  const tooltip = tooltipTemplate;
  const originalPointsTooltip = _.isEmpty(originalPoints) ?
    '' :
    tooltip({
      title: originalPoints[0].key,
      points: originalPoints,
    });

  return `<div class="perf-graph-tool-tip">${originalPointsTooltip}</div>`;
}
